import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    createLabAnalyzerSuccess, createLabAnalyzerFailure,
    getAllLabAnalyzerSuccess, getAllLabAnalyzerFailure,
    getByIdLabAnalyzerSuccess, getByIdLabAnalyzerFailure,
    updateLabAnalyzerSuccess, updateLabAnalyzerFailure,
    removeLabAnalyzerSuccess, removeLabAnalyzerFailure,
    getLabAnalyzerStatusSuccess, getLabAnalyzerStatusFailure,
    updateLabAnalyzerTestMappingSuccess, updateLabAnalyzerTestMappingFailure,
    getLabAnalyzerLogsSuccess, getLabAnalyzerLogsFailure,
    connectLabAnalyzerSuccess, connectLabAnalyzerFailure,
    disconnectLabAnalyzerSuccess, disconnectLabAnalyzerFailure,
    getSerialPortsSuccess, getSerialPortsFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* createRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers`, requestDetail);
        yield put(createLabAnalyzerSuccess(response));
    } catch (error) { yield put(createLabAnalyzerFailure(error?.response?.message || error)); }
}

function* getAllRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers`, requestDetail);
        yield put(getAllLabAnalyzerSuccess(response));
    } catch (error) { yield put(getAllLabAnalyzerFailure(error?.response?.message || error)); }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${action.payload}`, requestDetail);
        yield put(getByIdLabAnalyzerSuccess(response));
    } catch (error) { yield put(getByIdLabAnalyzerFailure(error?.response?.message || error)); }
}

function* updateRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers`, requestDetail);
        yield put(updateLabAnalyzerSuccess(response));
    } catch (error) { yield put(updateLabAnalyzerFailure(error?.response?.message || error)); }
}

function* removeRequest(action) {
    try {
        const requestDetail = {
            method: "DELETE",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${action.payload}`, requestDetail);
        yield put(removeLabAnalyzerSuccess(response));
    } catch (error) { yield put(removeLabAnalyzerFailure(error?.response?.message || error)); }
}

function* getStatusRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${action.payload}/status`, requestDetail);
        yield put(getLabAnalyzerStatusSuccess(response));
    } catch (error) { yield put(getLabAnalyzerStatusFailure(error?.response?.message || error)); }
}

function* updateTestMappingRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${id}/test-mapping`, requestDetail);
        yield put(updateLabAnalyzerTestMappingSuccess(response));
    } catch (error) { yield put(updateLabAnalyzerTestMappingFailure(error?.response?.message || error)); }
}

function* getLogsRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { id, page = 1, limit = 50, eventType = '' } = action.payload;
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${id}/logs?page=${page}&limit=${limit}`;
        if (eventType) url += `&eventType=${eventType}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getLabAnalyzerLogsSuccess(response));
    } catch (error) { yield put(getLabAnalyzerLogsFailure(error?.response?.message || error)); }
}

function* connectRequest(action) {
    try {
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${action.payload}/connect`, requestDetail);
        yield put(connectLabAnalyzerSuccess(response));
    } catch (error) { yield put(connectLabAnalyzerFailure(error?.response?.message || error)); }
}

function* disconnectRequest(action) {
    try {
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/${action.payload}/disconnect`, requestDetail);
        yield put(disconnectLabAnalyzerSuccess(response));
    } catch (error) { yield put(disconnectLabAnalyzerFailure(error?.response?.message || error)); }
}

function* getSerialPortsRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/analyzers/serial-ports/list`, requestDetail);
        yield put(getSerialPortsSuccess(response));
    } catch (error) { yield put(getSerialPortsFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labAnalyzer/createLabAnalyzerRequest', createRequest);
    yield takeLatest('labAnalyzer/getAllLabAnalyzerRequest', getAllRequest);
    yield takeLatest('labAnalyzer/getByIdLabAnalyzerRequest', getByIdRequest);
    yield takeLatest('labAnalyzer/updateLabAnalyzerRequest', updateRequest);
    yield takeLatest('labAnalyzer/removeLabAnalyzerRequest', removeRequest);
    yield takeLatest('labAnalyzer/getLabAnalyzerStatusRequest', getStatusRequest);
    yield takeLatest('labAnalyzer/updateLabAnalyzerTestMappingRequest', updateTestMappingRequest);
    yield takeLatest('labAnalyzer/getLabAnalyzerLogsRequest', getLogsRequest);
    yield takeLatest('labAnalyzer/connectLabAnalyzerRequest', connectRequest);
    yield takeLatest('labAnalyzer/disconnectLabAnalyzerRequest', disconnectRequest);
    yield takeLatest('labAnalyzer/getSerialPortsRequest', getSerialPortsRequest);
}

export default saga;
